import styled from 'styled-components';
import { FC } from 'react';
import AntCollapse from 'antd/lib/collapse';

import { CollapsePanelProps } from './types';

export const Panel = styled<FC<CollapsePanelProps & { withdescription: boolean }>>(
  AntCollapse.Panel,
)`
  .ant-collapse > & > .ant-collapse-header .ant-collapse-arrow {
    margin-right: 8px;
    font-size: 16px;
    padding: 4px 0;
    vertical-align: -4px;

    &.active svg {
      transform: rotate(90deg);
    }
  }

  .ant-collapse.middle && .ant-collapse-header {
    padding: ${props => (props.withdescription ? 8 : 20)}px 24px;
  }

  .ant-collapse.small && .ant-collapse-header {
    padding: ${props => (props.withdescription ? 4 : 12)}px 24px;
  }
`;
